import styled from "styled-components";
import {Text1, Title1} from "../../../../styles/business-components";

import Image from '../../../../assets/images/business/b_about_img2.png'

export const Container = styled.div`
  width: 100%;
  background-image: url("data:image/svg+xml,%3Csvg width='1920' height='307' viewBox='0 0 1920 307' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg opacity='0.2'%3E%3Cpath d='M0 93.6689V190.332C0 190.332 176.5 293.586 526.5 305.449C876.5 317.311 1309 211.422 1548 199.998C1787 188.574 1920.5 305.449 1920.5 305.449V54.5644C1920.5 54.5644 1823 -9.0748 1613.5 1.39981C1404 11.8744 1218 142.34 738.5 188.574C259 234.809 0 93.6689 0 93.6689Z' fill='white' fill-opacity='0.5'/%3E%3Cpath d='M0 93.6689V190.332C0 190.332 176.5 293.586 526.5 305.449C876.5 317.311 1309 211.422 1548 199.998C1787 188.574 1920.5 305.449 1920.5 305.449V54.5644C1920.5 54.5644 1823 -9.0748 1613.5 1.39981C1404 11.8744 1218 142.34 738.5 188.574C259 234.809 0 93.6689 0 93.6689Z' fill='url(%23paint0_linear_95_8931)' fill-opacity='0.5'/%3E%3Cpath d='M1921 179.036V193.655C1921 193.655 1744.45 249.543 1394.36 259.411C1044.27 269.279 612.694 191.376 372.597 164.696C132.5 138.015 0 223.411 0 223.411V149.016C0 149.016 79.0205 107.795 288.575 116.508C498.13 125.221 702.683 189.521 1182.31 227.98C1661.93 266.438 1921 179.036 1921 179.036Z' fill='url(%23paint1_linear_95_8931)' fill-opacity='0.6'/%3E%3Cpath d='M1921 179.036V193.655C1921 193.655 1744.45 249.543 1394.36 259.411C1044.27 269.279 612.694 191.376 372.597 164.696C132.5 138.015 0 223.411 0 223.411V149.016C0 149.016 79.0205 107.795 288.575 116.508C498.13 125.221 702.683 189.521 1182.31 227.98C1661.93 266.438 1921 179.036 1921 179.036Z' fill='url(%23paint2_linear_95_8931)'/%3E%3Cpath opacity='0.4' d='M0 128.819V146.394C0 146.394 176.5 249.648 526.5 261.511C876.5 273.374 1309 167.484 1548 156.06C1787 144.637 1920.5 261.511 1920.5 261.511V123.986C1920.5 123.986 1841.5 79.2399 1632 89.7145C1422.5 100.189 1218 177.49 738.5 223.724C259 269.959 0 128.819 0 128.819Z' fill='url(%23paint3_linear_95_8931)'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_95_8931' x1='4500.01' y1='520.99' x2='4502.58' y2='21.9135' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%234FC0C0' stop-opacity='0.41'/%3E%3Cstop offset='0.822917' stop-color='%2300637B'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_95_8931' x1='-2580.18' y1='391.828' x2='-2580.76' y2='155.449' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%234FC0C0'/%3E%3Cstop offset='0.822917' stop-color='%2300637B'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear_95_8931' x1='902.5' y1='399.013' x2='960' y2='141.513' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='white'/%3E%3Cstop offset='1' stop-color='%232F87A5'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint3_linear_95_8931' x1='4500.01' y1='384.635' x2='4500.84' y2='100.464' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%234FC0C0'/%3E%3Cstop offset='0.822917' stop-color='%2300637B'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E ");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom center;
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px 20px 100px 20px;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    gap: 100px;
    padding: 70px 200px 200px 300px;
  }
`

export const SmallContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto 1fr auto;
  gap: 10px;
  padding: 20px 20px 100px 20px;
`

export const ImageBlock = styled.div`
  background: url(${Image}) center no-repeat ${({theme}) => theme.business.colors.aboutImageBackground};
  background-size: contain;
  width: 120px;
  height: 120px;
  border-radius: 250px 250px 2px 250px;
  margin: auto;

  @media only screen and (${({theme}) => theme.media.small}) {
    width: 240px;
    height: 240px;
  }
  
  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    width: 500px;
    height: 500px;
    border-radius: 250px 250px 2px 250px;
  }
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-basis: 50%;
  gap: 20px;

  @media only screen and (${({theme}) => theme.media.medium}) {
    gap: 40px;
  }
`

export const ButtonItem = styled.div`
  grid-column-start: 2;
`

export const Title = styled(Title1)`
  font-size: 18px;
  font-weight: 400;
  line-height: 21px;

  margin-bottom: 0;
  grid-column-start: 2;

  @media only screen and (${({theme}) => theme.media.small}) {
    margin-bottom: 10px;
  }
  
  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 28px;
    line-height: 50px;
    font-weight: 600;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 32px;
    line-height: 60px;
    margin-bottom: 10px;
  }
`

export const Text = styled(Text1)`
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;

  margin-bottom: 0;

  @media only screen and (${({theme}) => theme.media.small}) {
    font-size: 16px;
  }
  
  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 18px;
    line-height: 40px;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 24px;
    line-height: 60px;
    margin-bottom: 20px;
  }
`

export const Help = styled.div`
  color: ${({theme}) => theme.business.colors.primary};
  font-family: ${({theme}) => theme.font.family};
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const ModalBody = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  padding: 0;

  @media only screen and (${({theme}) => theme.media.small}) {
    padding: 2rem 0;
    gap: 4rem;
  }
  
  @media only screen and (${({theme}) => theme.media.medium}) {
    gap: 4rem;
  }
`

export const QRCode = styled.img`
  width: 70%;
  height: auto;
  text-align: center;
`

export const ModalText = styled.div`
  text-align: center;
  font-size: 12px;
  color: ${({theme}) => theme.business.colors.primary};

  @media only screen and (${({theme}) => theme.media.small}) {
    font-size: 18px;
  }
  
  @media only screen and (${({theme}) => theme.media.medium}) {
    font-size: 25px;
  }
  
  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 30px;
  }
`

export const LargeScreen = styled.div`
  display: none;

  @media only screen and (${({theme}) => theme.media.small}) {
    display: block;
  }
`

export const SmallScreen = styled.div`
  display: block;

  @media only screen and (${({theme}) => theme.media.small}) {
    display: none;
  }
`